import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isJwtExpired, clearAuthStorage, getUserRoles } from "./api/auth";
import AppRouter from "./routes/AppRouter";

function clearAuthAndRedirect(navigate, fromPath) {
  clearAuthStorage();
  navigate("/login", { replace: true, state: { from: fromPath } });
}

function hasAllowedRole(token) {
  const roles = getUserRoles(token);
  return roles.some((role) =>
    [
      "ADMIN",
      "MODERATOR",
      "AUTHOR",
      "ROLE_ADMIN",
      "ROLE_MODERATOR",
      "ROLE_AUTHOR",
    ].includes(role),
  );
}

function SessionGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("build 2026-04-22");
    const isAuthRoute = location.pathname === "/login";

    const check = () => {
      if (isAuthRoute) return;

      const token = localStorage.getItem("access_token");

      if (!token || isJwtExpired(token) || !hasAllowedRole(token)) {
        clearAuthAndRedirect(navigate, location.pathname);
      }
    };

    check();

    const interval = window.setInterval(check, 15_000);

    const onStorage = (e) => {
      if (e.key === "access_token") {
        check();
      }
    };

    window.addEventListener("storage", onStorage);

    return () => {
      window.clearInterval(interval);
      window.removeEventListener("storage", onStorage);
    };
  }, [navigate, location.pathname]);

  return children;
}

function App() {
  return (
    <SessionGuard>
      <AppRouter />
    </SessionGuard>
  );
}

export default App;
